<ng-select
  [(ngModel)]="innerValue"
  (ngModelChange)="onAlarmaChange($event)"
  [items]="alarmas"
  [bindLabel]="'numeroAbonado'"
  [placeholder]="idCliente ? placeholder : 'Seleccioná un cliente primero'"
  notFoundText="No se encontraron alarmas"
  [loading]="loading"
  [disabled]="disabled || !idCliente"
  [clearable]="clearable"
  [searchable]="true"
  [virtualScroll]="true"
  [dropdownPosition]="'auto'"
  appendTo="body"
  class="custom-ng-select"
>
  <ng-template ng-option-tmp let-item="item">
    <div>
      <span>{{ alarmaLabel(item) }}</span>
    </div>
  </ng-template>
  <ng-template ng-label-tmp let-item="item">
    <span>{{ alarmaLabel(item) }}</span>
  </ng-template>
</ng-select>
